import America from '~/assets/images/artcategories/america.svg';
import Animals from '~/assets/images/artcategories/animals.svg';
import Charity from '~/assets/images/artcategories/charity.svg';
import Colleges from '~/assets/images/artcategories/colleges.svg';
import Emojis from '~/assets/images/artcategories/faceemojis.svg';
import FoodDrink from '~/assets/images/artcategories/fooddrink.svg';
import GreekLife from '~/assets/images/artcategories/greeklife.svg';
import LettersNumbers from '~/assets/images/artcategories/lettersnumbers.svg';
import Mascots from '~/assets/images/artcategories/mascots.svg';
import Military from '~/assets/images/artcategories/military.svg';
import MostPopular from '~/assets/images/artcategories/mostpopular.svg';
import Music from '~/assets/images/artcategories/music.svg';
import Nature from '~/assets/images/artcategories/nature.svg';
import Occupations from '~/assets/images/artcategories/occupations.svg';
import PartiesEvents from '~/assets/images/artcategories/partiesevents.svg';
import People from '~/assets/images/artcategories/people.svg';
import QuotesPhrases from '~/assets/images/artcategories/quotesphrases.svg';
import Religion from '~/assets/images/artcategories/religion.svg';
import School from '~/assets/images/artcategories/school.svg';
import SeasonsHolidays from '~/assets/images/artcategories/seasonsholidays.svg';
import ShapesSymbols from '~/assets/images/artcategories/shapessymbols.svg';
import SportsGames from '~/assets/images/artcategories/sportsgames.svg';
import Transportation from '~/assets/images/artcategories/transportation.svg';
import Travel from '~/assets/images/artcategories/travel.svg';

export const artCategorySVGs = {
  America,
  Animals,
  Charity,
  Colleges,
  Emojis,
  'Food/Drink': FoodDrink,
  'Greek Life': GreekLife,
  'Letters/Numbers': LettersNumbers,
  Mascots,
  Military,
  'Most Popular': MostPopular,
  Music,
  Nature,
  Occupations,
  'Parties/Events': PartiesEvents,
  People,
  'Quotes/Phrases': QuotesPhrases,
  Religion,
  School,
  'Seasons/Holidays': SeasonsHolidays,
  'Shapes/Symbols': ShapesSymbols,
  'Sports/Games': SportsGames,
  Transportation,
  Travel
};

export const MOST_POPULAR = {
  name: 'Most Popular',
  keyword: 'mostpopular',
  id: 1559,
  rank: 22,
  leaf: true,
  _embedded: {
    children: []
  }
};

export const RECENTLY_USED = {
  name: 'Recently Used',
  keyword: 'recents',
  categoryName: 'sub/recents',
  categoryPath: 'addArt/sub/recents',
  embedded: () => {},
  embeddedResourceArray: () => {}
};

export const artCategories = [
  'Emojis',
  'Shapes/Symbols',
  'Sports/Games',
  'Letters/Numbers',
  'Animals',
  'Mascots',
  'Nature',
  'America',
  'Parties/Events',
  'Military',
  'Occupations',
  'Colleges',
  'Music',
  'Transportation',
  'Greek Life',
  'School',
  'Charity',
  'People',
  'Religion',
  'Food/Drink',
  'Seasons/Holidays',
  'Quotes/Phrases',
  'Travel',
  'Most Popular'
];

export const fundraisingArtCategories = [
  'Most Popular',
  'Charity',
  'Shapes/Symbols',
  'Sports/Games',
  'Animals',
  'Mascots',
  'Quotes/Phrases',
  'Religion',
  'People',
  'Emojis',
  'Letters/Numbers',
  'School',
  'America',
  'Nature',
  'Travel',
  'Military',
  'Occupations',
  'Music',
  'Parties/Events',
  'Colleges',
  'Transportation',
  'Greek Life',
  'Food/Drink',
  'Seasons/Holidays'
];
